import { AcceleratorCatalog } from "../services/accelerator-catalog";

export class AcceleratorCatalogRefresh {
    static readonly type = '[AcceleratorCatalog] Refresh';
}

export class AcceleratorCatalogRefreshByID {
    static readonly type = '[AcceleratorCatalog] Refresh By ID';
    constructor(public id: number) { }
}

export class AcceleratorCatalogCreate {
    static readonly type = '[AcceleratorCatalog] Create';
    constructor(public item: AcceleratorCatalog) { }
}

export class AcceleratorCatalogUpdate {
    static readonly type = '[AcceleratorCatalog] Update';
    constructor(
        public id: number,
        public item: AcceleratorCatalog
    ) { }
}

export class AcceleratorCatalogDelete {
    static readonly type = '[AcceleratorCatalog] Delete';
    constructor(public id: number) { }
}